import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=37808c5f&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=ts"
export * from "./MainDashboard.vue?vue&type=script&lang=ts"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&id=37808c5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37808c5f",
  null
  
)

export default component.exports